export default {
  variants: [
    {
      props: { variant: "info" },
      style: {
        width: "400px",
        backgroundColor: "#ffffff",
        color: "#3A3A4A",
        border: "1px #E7E7EA solid",
        boxShadow: "0px 2px 5px 1px #0000001C",
        ".MuiAlert-icon": {
          backgroundColor: "rgba(135, 211, 242, 0.15)",
          borderRadius: "100px",
          padding: "10px",
          ".MuiSvgIcon-root": {
            color: "rgba(53, 164, 232, 1)",
          },
        },
        ".MuiAlert-action": {
          padding: "8px 0 0 16px",
          ".MuiIconButton-root": {
            ".MuiSvgIcon-root": {
              fontSize: "1.1em",
            },
          },
        },
      },
    },
    {
      props: { variant: "error" },
      style: {
        width: "400px",
        backgroundColor: "#ffffff",
        color: "#3A3A4A",
        border: "1px #E7E7EA solid",
        boxShadow: "0px 2px 5px 1px #0000001C",
        ".MuiAlert-icon": {
          backgroundColor: "rgba(255,154,145,0.15)",
          borderRadius: "100px",
          padding: "10px",
          ".MuiSvgIcon-root": {
            color: "#F95D54",
          },
        },
        ".MuiAlert-action": {
          padding: "8px 0 0 16px",
          ".MuiIconButton-root": {
            ".MuiSvgIcon-root": {
              fontSize: "1.1em",
            },
          },
        },
      },
    },
    {
      props: { variant: "warning" },
      style: {
        width: "400px",
        backgroundColor: "#ffffff",
        color: "#3A3A4A",
        border: "1px #E7E7EA solid",
        boxShadow: "0px 2px 5px 1px #0000001C",
        ".MuiAlert-icon": {
          backgroundColor: "rgba(255,154,145,0.15)",
          borderRadius: "100px",
          padding: "10px",
          ".MuiSvgIcon-root": {
            color: "#F95D54",
          },
        },
        ".MuiAlert-action": {
          padding: "8px 0 0 16px",
          ".MuiIconButton-root": {
            ".MuiSvgIcon-root": {
              fontSize: "1.1em",
            },
          },
        },
      },
    },
    {
      props: { variant: "success" },
      style: {
        width: "400px",
        backgroundColor: "#ffffff",
        color: "#3A3A4A",
        border: "1px #E7E7EA solid",
        boxShadow: "0px 2px 5px 1px #0000001C",
        ".MuiAlert-message": {
          padding: "12px 0",
        },
        ".MuiAlert-icon": {
          backgroundColor: "rgba(140, 232, 173, 0.15)",
          borderRadius: "100px",
          padding: "10px",
          ".MuiSvgIcon-root": {
            color: "rgba(52, 199, 104, 1)",
          },
        },
        ".MuiAlert-action": {
          padding: "8px 0 0 16px",
          ".MuiIconButton-root": {
            ".MuiSvgIcon-root": {
              fontSize: "1.1em",
            },
          },
        },
      },
    },
  ],
};
